import type { InlineMessageDesignTokens } from '@primeuix/themes/types/inlinemessage'

export default {
  icon: {
    size: '1.125rem',
  },
  root: {
    gap: '0.5rem',
    padding: '{form.field.padding.y} {form.field.padding.x}',
    borderRadius: '{content.border.radius}',
  },
  text: {
    fontWeight: '500',
  },
  colorScheme: {
    dark: {
      info: {
        color: '{blue.500}',
        shadow: 'none',
        background: 'color-mix(in srgb, {blue.500}, transparent 84%)',
        borderColor: 'color-mix(in srgb, {blue.500}, transparent 84%)',
      },
      warn: {
        color: '{yellow.500}',
        shadow: 'none',
        background: 'color-mix(in srgb, {yellow.500}, transparent 84%)',
        borderColor: 'color-mix(in srgb, {yellow.500}, transparent 84%)',
      },
      error: {
        color: '{red.500}',
        shadow: 'none',
        background: 'color-mix(in srgb, {red.500}, transparent 84%)',
        borderColor: 'color-mix(in srgb, {red.500}, transparent 84%)',
      },
      success: {
        color: '{green.500}',
        shadow: 'none',
        background: 'color-mix(in srgb, {green.500}, transparent 84%)',
        borderColor: 'color-mix(in srgb, {green.500}, transparent 84%)',
      },
      contrast: {
        color: '{surface.950}',
        shadow: 'none',
        background: '{surface.0}',
        borderColor: '{surface.0}',
      },
      secondary: {
        color: '{surface.300}',
        shadow: 'none',
        background: '{surface.800}',
        borderColor: '{surface.800}',
      },
    },
    light: {
      info: {
        color: '{blue.600}',
        shadow: 'none',
        background: 'color-mix(in srgb, {blue.50}, transparent 5%)',
        borderColor: 'color-mix(in srgb, {blue.50}, transparent 5%)',
      },
      warn: {
        color: '{yellow.600}',
        shadow: 'none',
        background: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
        borderColor: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
      },
      error: {
        color: '{red.600}',
        shadow: 'none',
        background: 'color-mix(in srgb, {red.50}, transparent 5%)',
        borderColor: 'color-mix(in srgb, {red.50}, transparent 5%)',
      },
      success: {
        color: '{green.600}',
        shadow: 'none',
        background: 'color-mix(in srgb, {green.50}, transparent 5%)',
        borderColor: 'color-mix(in srgb, {green.50}, transparent 5%)',
      },
      contrast: {
        color: '{surface.50}',
        shadow: 'none',
        background: '{surface.900}',
        borderColor: '{surface.900}',
      },
      secondary: {
        color: '{surface.600}',
        shadow: 'none',
        background: '{surface.100}',
        borderColor: '{surface.100}',
      },
    },
  },
} satisfies InlineMessageDesignTokens
